import RightPopupComponent from "components/RightPopup";

import Button from "components/Button";
import DentalFormula from "components/DentalFormula";
import SelectDatePeriod from "components/SelectDatePeriod";

import { ReactComponent as CheckIcon } from 'icons/components/check.svg';
import { ReactComponent as ArrowIcon } from 'icons/components/arrow.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';
import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';

import './index.less';
import './themes/default.less';

export default class PlanStageAddEditPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            step: 1,
            needName: false,
            isDiscFixed: false,
            searchWord: "",
            info: {}
        };

        this.totalSum = 0;

        this.state = { ...this.defaultState };
        this.periods = [1, 2, 3, 4, 5, 6, 12].map(id => {
            const name = ((id === 1 || id === 12) ? "1 " : "") + this._helper.date.diffFrom(null, this._helper.date.addMonth(null, id));
            return { id, name };
        });
    }

    get popupName() {
        return "planStageAddEditPopup";
    }

    async show(info, hideCb) {
        this.info = info;
        this.hideCb = hideCb;

        this.prepareInfo(info);

        await this.loadPrices();
        await this.loadData();

        super.show();
    }

    prepareInfo(info) {
        this.dialogTitle = info?.id ? "treatmentPlan.editStage" : "treatmentPlan.addingStage";

        if (info?.id) {
            const { id, doctorId, notes, treatmentDirectionId, workStatus, duration,
                activityDate, title, agreed, intendedTreatmentDate, type } = info;
            this.state.info = {
                id, doctorId, notes, treatmentDirectionId, workStatus,
                duration, activityDate, title, agreed, intendedTreatmentDate, type
            };
            this.state.needName = true;
        } else
            this.state.info = { notes: "" };

        this.prepareSecondInfo(info?.preSecuredInvoice);

        if (this.validateMainInfo() && this.state.info?.teeth?.length > 1)
            this.state.step = 3;
    }

    prepareSecondInfo(info) {
        let { teeth, securedInvoiceItems } = info || {};
        const invoice = [];

        if (!securedInvoiceItems && teeth?.length) {
            teeth.forEach(n => {
                securedInvoiceItems.push({ teeth: [n], items: [] });
            });
        }
        else if (!this.state.info.invoice?.length && securedInvoiceItems?.length) {
            const map = {};
            securedInvoiceItems.forEach(it => {
                const th = it.teeth?.length > 0 ? it.teeth : [100];
                th.sort();

                const thStr = JSON.stringify(th);
                if (!map[thStr])
                    map[thStr] = {};

                const { title, code, altCode, price, discount, count, noDiscount, priceCategoriesId } = it;
                const priceId = altCode + title + code + price;
                if (!map[thStr][priceId]) {
                    map[thStr][priceId] = {
                        priceId,
                        name: title,
                        code,
                        altCode,
                        value: price,
                        discount,
                        count,
                        noDiscount,
                        priceCategoriesId
                    };
                }
            });
            Object.keys(map).forEach(key => {
                const th = JSON.parse(key);
                const items = Object.values(map[key]);

                invoice.push({ teeth: th, items });
            });
        }

        this.state.info.teeth = teeth || [];
        this.state.info.invoice = invoice || [];
        this.state.info.discount = (info?.id || this.isPrel) ? (info?.discount || 0) : (globalThis.appPageView.state?.info?.discount || 0);
    }

    setPriceId(item) {
        const { altCode, code, value, name } = item;
        item.priceId = altCode + name + code + value;
        if (item.items && item.items.length > 0)
            item.items.forEach(it => this.setPriceId(it));
        return item;
    }

    getItemsPrices(item) {
        let rows = [];
        item.items.forEach(it => {
            rows.push(it);
            if (it.items)
                rows = [...rows, ...this.getItemsPrices(it)];
        });
        return rows;
    }

    async loadPrices() {
        this._helper.showLoading();
        const resp = await this._request.priceCategories.getCurrent();
        this._helper.hideLoading();

        const prices = this.setPriceId((resp?.data && resp.data[0]) || {});
        this.prices = [prices, ...this.getItemsPrices(prices)];
    }

    async loadData() {

    }

    getDiagnosisTeeth(data) {
        const { diagnosis } = this._config;
        const mapDiagnosis = diagnosis.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
        const diagnosisTeeth = data.dentalFormula.reduce((acc, it, i) => {
            if (it)
                acc[i + 1] = it.split(",").map(item => mapDiagnosis[+item]);
            return acc;
        }, {});
        return diagnosisTeeth;
    }

    async onShow() {
        this._helper.showLoading();
        //const clientInfo = globalThis.appPageView.state?.info;

        //const inspection = await this._request.medInspection.getForClient(clientInfo.id);
        //const insp = inspection?.data;
        this.diagnosisTeeth = {};
        //if (insp.length)
        //    this.diagnosisTeeth = this.getDiagnosisTeeth(insp[0]);

        this._helper.hideLoading();

        this.setSelfData();
    }

    componentDidUpdate() {
        super.componentDidUpdate();

        this.setSelfData();
    }

    setSelfData() {
        const { info, step } = this.state;
        const { teeth } = info;

        if (step === 2 && this.teethSelector) {
            this.teethSelector.setTeeth(teeth || []);
            return;
        }
    }

    stepBack() {
        this.state.searchWord = "";

        this.changeStep(-1);
    }

    changeInfoState(key, value, cb) {
        const { info } = this.state;
        info[key] = value;

        this.setState({ info }, cb?.apply ? cb : null);
    }

    changeActivityDate(date) {
        //const date = this._helper.date.toStr(this._helper.date.addMonth(null, n));
        this.changeInfoState("activityDate", date);
    }

    changeDiscount(value) {
        if (value === "")
            return;

        const { info, isDiscFixed } = this.state;

        if (isDiscFixed) {
            const totalSum = info.invoice.reduce((acc, it) => {
                it.items.forEach(it2 => {
                    if (!it2.noDiscount)
                        acc += (it2.value * it2.count);
                });
                return acc;
            }, 0);

            value = (100 * value / totalSum);
        }

        info.discount = value;
        info.invoice.forEach(it => {
            it.items.forEach(it2 => {
                it2.discount = it2.noDiscount ? 0 : value;
            });
        });

        this.setState({ info });
    }

    changeTeethState(teeth) {
        const { info } = this.state;

        info.teeth = teeth;

        const invoice = info.invoice || [];

        teeth.forEach(n => {
            if (!invoice.find(it => it.teeth.includes(n)))
                invoice.push({ teeth: [n], items: [] });
        });

        invoice.forEach(it => {
            it.teeth = it.teeth.filter(t => teeth.includes(t));
        });

        info.invoice = invoice.filter(it => it.teeth.length > 0);

        this.setState({ info });
    }

    removeTeeth(n, e) {
        this._helper.stopEvent(e);

        const teeth = this.state.info.teeth.filter(it => it !== n);
        this.changeTeethState(teeth);
    }

    togglePriceItem(id) {
        const item = this.priceNodes[id];
        const icon = item.querySelector(".icon");
        const cont = item.querySelector(".subItems");

        const opened = this._helper.dom.hasClass(icon, "rotate90m");

        this._helper.dom.removeClass(icon, ["rotate90", "rotate90m"]);
        this._helper.dom.addClass(icon, opened ? "rotate90" : "rotate90m");

        this._helper.dom.display(cont, !opened);
    }

    onPricesContDrop() {
        this.selectPricesCont();

        const item = globalThis.currentDropValue;
        delete globalThis.currentDropValue;

        if (item?.type === "tooth")
            this.reorderTooth(item);
    }

    selectPricesCont(e) {
        const curr = this.invoicesCont.querySelector(".dndCont.active");
        if (curr)
            this._helper.dom.removeClass(curr, "active");

        const cont = this._helper.dom.getParentByClass(e?.target, "dndCont");
        if (cont)
            this._helper.dom.addClass(cont, "active");
    }

    onPricesItemDrop(e) {
        this._helper.stopEvent(e);

        this.selectPricesCont(e);

        const item = globalThis.currentDropValue;
        delete globalThis.currentDropValue;

        if (item?.type === "price")
            this.onPriceItemClicked(item.it);
        else if (item?.type === "tooth")
            this.reorderTooth(item);
    }

    onPriceItemClicked(info) {
        const cont = this.invoicesCont.querySelector(".dndCont.active");
        this.addRemoveInvoicePriceItem(cont, info);
    }

    reorderTooth(item) {
        const cont = this.invoicesCont.querySelector(".dndCont.active");
        if (!item?.cont || !item?.n || cont === item.cont)
            return;

        const index = item.cont.dataset.index;

        let invoice = this.state.info.invoice;

        invoice[index].teeth = invoice[index].teeth.filter(t => t !== item.n);
        if (cont)
            invoice[cont.dataset.index].teeth.push(item.n);
        else
            invoice.push({ teeth: [item.n], items: [] });

        invoice = invoice.filter(it => it.teeth.length > 0);

        this.changeInfoState("invoice", invoice, this.onTeethStructChaned.bind(this, item.n));
    }

    onTeethStructChaned(n) {
        let index = -1;
        this.state.info.invoice.forEach((it, i) => {
            if (it.teeth.includes(n))
                index = i;
        });

        const target = this.invoicesCont.children[index];
        if (target)
            this.selectPricesCont({ target });
    }

    onTeethItemClicked(n, e) {
        this._helper.stopEvent(e);

        clearTimeout(this.selectPricesContTimer);

        if (e.type === "dblclick") {
            const cont = this._helper.dom.getParentByClass(e.target, "dndCont");
            this.reorderTooth({ n, cont });
        }
        else {
            this.selectPricesContTimer = setTimeout(() => {
                clearTimeout(this.selectPricesContTimer);
                this.selectPricesCont(e);
            }, 300);
        }
    }

    onPriceItemRemove(info, e) {
        this._helper.stopEvent(e);

        const cont = this._helper.dom.getParentByClass(e.target, "dndCont");
        this.addRemoveInvoicePriceItem(cont, info, true);
    }

    addRemoveInvoicePriceItem(cont, info, removing = false) {
        const priceId = info?.priceId;

        if (!cont || !priceId)
            return;

        const index = cont.dataset.index;
        let { invoice } = this.state.info;

        if (!invoice[index].items)
            return;

        if (removing) {
            invoice[index].items = invoice[index].items.filter(it => it.priceId !== priceId);

            invoice = invoice.filter(it => it.teeth.length > 0);
        }
        else {
            const isList = invoice[index].items.find(it => it.priceId === priceId);
            if (isList)
                isList.count++;
            else {
                const { value, noDiscount, altCode, code, name, id: priceCategoriesId } = info;
                const discount = noDiscount ? 0 : this.state.info.discount;

                invoice[index].items.push({
                    priceId,
                    name,
                    code,
                    altCode,
                    count: 1,
                    value,
                    discount,
                    noDiscount,
                    priceCategoriesId
                });
            }
        }

        this.changeInfoState("invoice", invoice);
    }

    onPriceItemCountChange(info, value, input) {
        const cont = this._helper.dom.getParentByClass(input, "dndCont");
        const index = cont.dataset.index;
        const { invoice } = this.state.info;
        if (!invoice[index].items)
            return;

        const item = invoice[index].items.find(it => it.priceId === info.priceId);
        if (item)
            item.count = value;

        this.changeInfoState("invoice", invoice);
    }

    save() {
        let { step } = this.state;

        if (step === 1 && !this.validateMainInfo())
            return;

        if (step === 2 && this.state.info.teeth?.length < 1)
            return;

        if (step < 3)
            return this.changeStep(1);

        this.saveData();
    }

    changeStep(flag) {
        const step = this.state.step + flag;

        this.setState({ step });
    }

    checkInfoBeforeSave(info) {
        if (!this.state.needName || !info.title) {
            const { treatmentDirection } = this._config;
            const item = treatmentDirection.find(it => it.id === info.treatmentDirectionId);

            info.title = item?.name ? this.tr(item.name) : "";
        }

        info.securedInvoiceItems?.map(it => {
            it.items?.map(item => {
                delete item.priceId;
                return item;
            });
            return it;
        });

        return info;
    }

    getCorrectProcent({ value, discount }) {
        const roundValue = parseFloat((Math.round(this._helper.number.percentMinus(value, discount) * 10) / 10).toFixed(1));
        const newDiscount = ((value - roundValue) / value) * 100;
        return newDiscount;
    }

    saveData() {
        if (!this.validateMainInfo())
            return;

        const info = { ...this.state.info };
        const { discount, agreed, invoice } = info;
        info.agreed = (agreed === 0 || agreed === true) ? true : false;
        info.sortIndex = 0;

        if (invoice?.length < 1 || invoice.find(it => !it.items.length))
            return;
        const { totalWithPercent } = this.getTotal(invoice);
        const res = this._helper.number.calculatePercentForInvoice(invoice, discount, totalWithPercent);

        if (res.error) {
            return this.showError(res.error, "Ошибка при формировании скидки");
        }

        info.securedInvoiceItems = res.rows;

        delete info.invoice;

        this.hideCb(this.checkInfoBeforeSave(info));
        this.hide();
    }

    validateMainInfo() {
        const { id, doctorId, treatmentDirectionId, workStatus, duration, activityDate, intendedTreatmentDate, type } = this.state.info;
        if (treatmentDirectionId !== undefined)
            this.directionSelector && this.directionSelector.validate();

        if (!activityDate)
            this.selectDatePeriod && this.selectDatePeriod.validate();

        if (!type)
            this.planType && this.planType.validate();

        this.workStatusSelector && this.workStatusSelector.validate();
        this.durationInput && this.durationInput.validate();

        if (!doctorId || !treatmentDirectionId || !workStatus || !duration || (!id && !activityDate) || !intendedTreatmentDate || !type)
            return false;

        return true;
    }

    renderFirstStep() {
        const { treatmentDirection, treatmentWorkStatus } = this._config;
        const { info, needName } = this.state;
        const { agreed, doctorId, treatmentDirectionId, workStatus, notes, duration, title, type, intendedTreatmentDate, activityDate } = info;

        return (
            <div className="flex gap24">
                <div className="flex1 flex col gap16">
                    <div>
                        {this.insertRadioBlock({
                            ref: el => this.planType = el,
                            title: "client.planType",
                            items: [{
                                key: 0,
                                name: "client.recommendedPlan",
                                value: "RECOMMENDER",
                            },
                            {
                                key: 1,
                                name: "client.alternativePlan",
                                value: "ALTERNATIVE",
                            }],
                            value: type,
                            onChange: this.changeInfoState.bind(this, "type"),
                            required: true
                        })}
                    </div>
                    <div className="flex gap16">
                        <div className="flex1">
                            {this.insertSelect({
                                ref: el => this.directionSelector = el,
                                itemStyle: "flex1",
                                label: "treatmentPlan.treatmentDir",
                                placeHolder: "main.notIndicated",
                                translate: true,
                                required: true,
                                showLeftIcon: false,
                                items: treatmentDirection,
                                value: treatmentDirectionId,
                                onChange: this.changeInfoState.bind(this, "treatmentDirectionId"),
                            })}
                        </div>
                        <div className="flex1 flex col gap8">
                            {/*this.insertSelect({
                                ref: el => this.validitySelector = el,
                                showLeftIcon: false,
                                label: "main.validity",
                                placeHolder: "main.notIndicated",
                                helpText: "question.validityDate",
                                required: !id,
                                translate: true,
                                items: this.periods,
                                onChange: this.changeActivityDate.bind(this),
                            })*/}
                            {/*!!activityDate && (
                                <div className="activityDate text p2">{this.tr("treatmentPlan.finalDate")} {this._helper.date.toDateStr(activityDate)}</div>
                            )*/}
                            <SelectDatePeriod
                                ref={el => this.selectDatePeriod = el}
                                onChange={this.changeActivityDate.bind(this)}
                                defaultValue={activityDate ? new Date(activityDate) : null} />
                        </div>
                    </div>
                    {this.insertToggleSwitch({
                        checked: needName,
                        label: "treatmentPlan.uStageName",
                        onChange: this.toggleState.bind(this, "needName")
                    })}
                    {needName && (
                        <div className="flex1 flex col gap8">
                            {this.insertInput({
                                label: "treatmentPlan.stageName",
                                value: title,
                                onChange: this.changeInfoState.bind(this, "title")
                            })}
                        </div>
                    )}
                    <div className="flex gap16">
                        <div className="flex1">
                            {this.insertInput({
                                ref: el => this.durationInput = el,
                                type: "number",
                                label: "treatmentPlan.visitsNumber",
                                placeHolder: "main.notIndicated",
                                required: true,
                                value: duration,
                                inputProps: {
                                    min: 1,
                                    max: 50,
                                    step: 1,
                                },
                                validator: this._helper.inputValidators.number,
                                onChange: this.changeInfoState.bind(this, "duration")
                            })}
                        </div>
                        <div className="flex1">
                            {this.insertSelect({
                                ref: el => this.workStatusSelector = el,
                                itemStyle: "flex1",
                                label: "treatmentPlan.treatmentStatus",
                                placeHolder: "main.notIndicated",
                                translate: true,
                                required: true,
                                showLeftIcon: false,
                                items: treatmentWorkStatus,
                                value: workStatus,
                                onChange: this.changeInfoState.bind(this, "workStatus")
                            })}
                        </div>
                    </div>
                    <div className="flex">
                        <div className="flex1">
                            {this.insertRadioBlock({
                                title: "client.agreedWithPatient",
                                items: [{
                                    key: 0,
                                    name: "client.yes",
                                    value: 0,
                                },
                                {
                                    key: 1,
                                    name: "client.no",
                                    value: 1,
                                }],
                                value: agreed ? 0 : 1,
                                onChange: this.changeInfoState.bind(this, "agreed"),
                            })}
                        </div>
                        <div className="flex1" style={{ paddingLeft: "16px" }}>
                            {this.insertSelectDate({
                                label: "client.recomTreatmentDate",
                                onChange: this.changeInfoState.bind(this, "intendedTreatmentDate"),
                                defaultValue: intendedTreatmentDate,
                            })}
                        </div>
                    </div>
                    {this.insertTextarea({
                        itemStyle: "note",
                        label: "client.note",
                        value: notes,
                        onChange: this.changeInfoState.bind(this, "notes")
                    })}
                </div>
                <div className="flex1">
                    {this.insertSelectDoctor({
                        value: doctorId,
                        label: "client.doctor",
                        required: true,
                        onClick: this.changeInfoState.bind(this, "doctorId")
                    })}
                </div>
            </div>
        );
    }

    renderSecondStep() {
        return (
            <DentalFormula
                ref={el => this.teethSelector = el}
                onChangeTeeth={this.changeTeethState.bind(this)}
                diagnosisTeeth={this.diagnosisTeeth}
            />
        );
    }

    insertPriceCat(info) {
        const { id, name, items } = info;

        if (items.length < 1)
            return this.insertPriceItem(info);

        return (
            <div key={id} ref={el => this.priceNodes[id] = el} className="item flex col gap16">
                <div className="flex centerV gap8 hand" onClick={this.togglePriceItem.bind(this, id)}>
                    <ArrowIcon className="icon rotate90" />
                    <div className="text p1SemiBold">{name}</div>
                </div>
                <div className="subItems flex col gap16" style={{ display: "none" }}>
                    {items.map(subIt => this.insertPriceCat(subIt))}
                </div>
            </div>
        );
    }

    insertPriceItem(it) {
        const { id, name, altCode, value } = it;
        const sum = this._helper.number.toSum(value);

        return (
            <div
                key={id}
                className="subItem hand"
                draggable="true"
                onDoubleClick={this.onPriceItemClicked.bind(this, it)}
                onDragStart={() => {
                    globalThis.currentDropValue = { it, type: "price" };
                }}
            >
                <div className="name text p1">{name}</div>
                <div className="info flex gap8 text p2">
                    <div className="flex1">{altCode}</div>
                    <div>{sum}</div>
                </div>
            </div>
        );
    }

    insertInvoiceItem(key, { teeth, items }) {
        return (
            <div
                key={`item_${key}`}
                className="row group border flex dndCont"
                onClick={this.selectPricesCont.bind(this)}
                onDragOver={e => { e.preventDefault(); }}
                onDrop={this.onPricesItemDrop.bind(this)}
                data-index={key}
            >
                <div className="column first flex wrap start contentStart gap8">
                    {teeth.map(n => {
                        const text = n < 100 ? (
                            `${this._helper.string.capitalize(this.tr("client.tooth"))} ${n}`
                        ) : this._helper.getTeethName(n);

                        return (
                            <div
                                key={n}
                                className="teeth rad16 flex centerV"
                                draggable="true"
                                onDragStart={e => {
                                    const cont = this._helper.dom.getParentByClass(e.target, "dndCont");
                                    globalThis.currentDropValue = { n, cont, type: "tooth" };
                                }}
                                onClick={this.onTeethItemClicked.bind(this, n)}
                                onDoubleClick={this.onTeethItemClicked.bind(this, n)}
                            >
                                <div className="text p2">{text}</div>
                                <CloseIcon className="hand" onClick={this.removeTeeth.bind(this, n)} />
                            </div>
                        );
                    })}
                </div>
                <div
                    className="column flex1 flex col gap8 centerH"
                >
                    {items.map((it, i) => this.insertInvoicePriceItem(i, it))}
                    {items.length < 1 && (
                        <div key="addKey" className="addNew flex centerV gap8 hand">
                            <PlusIcon />
                            <div className="text p1">{this.tr("treatmentPlan.addNewPrice")}</div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    insertInvoicePriceItem(key, it) {
        const { count, name, value, noDiscount, discount, altCode } = it;
        let disc = noDiscount ? 0 : discount;
        const value2 = this._helper.number.percentMinus(value, disc);
        const sum = this._helper.number.toSum(value);
        const sum2 = this._helper.number.toSum(value2 * count);
        const sn = "%";

        const parts = disc.toString().split('.');
        if (parts && parts[1] && parts[1].length > 2)
            disc = parseFloat(disc.toFixed(2));

        return (
            <div
                key={key} className="invoicePriceItem flex centerV gap8">
                <div className="name flex1 text p1 rad4 hidden">
                    <div className="inner hidden" data-tooltip={`${altCode} ${name}`} data-tooltip-max-width={400}>{name}</div>
                </div>
                {this.insertInput({
                    itemStyle: "count text p1",
                    type: "number",
                    value: count,
                    inputProps: {
                        min: 1,
                        max: 1000,
                        step: 1,
                    },
                    validator: this._helper.inputValidators.number,
                    onChange: this.onPriceItemCountChange.bind(this, it)
                })}
                <div className="cost text p1">
                    <div className="disc">{sum} - {disc}{sn}</div>
                    <div>{sum2}</div>
                </div>
                <CloseIcon className="hand" onClick={this.onPriceItemRemove.bind(this, it)} />
            </div>
        );
    }

    getTotal(invoice) {
        let total = 0;
        let totalWithPercent = 0;
        let totalForDisc = 0;

        invoice.forEach(it => {
            let totalGr = 0;
            let totalPr = 0;
            let totalDs = 0;
            it.items.forEach(it2 => {
                const { count, value, noDiscount } = it2;
                const selfSum = ((count || 0) * (value || 0));
                //const selfSum2 = (value || 0);
                totalGr += selfSum;
                totalDs += noDiscount ? 0 : selfSum;
                totalPr += (noDiscount ? selfSum : this._helper.number.percentMinus(selfSum, it2.discount));
            });

            total += totalGr;
            totalWithPercent += totalPr;
            totalForDisc += totalDs;
        });

        total = Math.round(total);
        totalWithPercent = Math.round(totalWithPercent);
        this.totalSum = total;

        return { total, totalWithPercent, totalForDisc };
    }

    renderThirdStep() {
        const { info, searchWord, isDiscFixed } = this.state;
        const { invoice, discount } = info;

        const word = this._helper.string.normalize(searchWord);

        const items = word ? Object.values(this.prices).filter(({ altCode, name }) => {
            const normalizedAltCode = altCode ? this._helper.string.normalize(altCode) : '';
            const normalizedName = name ? this._helper.string.normalize(name) : '';
            return (
                normalizedAltCode.includes(word) ||
                normalizedName.includes(word) ||
                this._helper.string.isSimilar(word, normalizedAltCode) ||
                this._helper.string.isSimilar(word, normalizedName)
            );
        }) : this.prices[0].items;

        this.priceNodes = {};

        const { total, totalWithPercent, totalForDisc } = this.getTotal(invoice);

        const disc = !isDiscFixed ? discount : Math.round(totalForDisc * discount / 100);
        const discL = isDiscFixed ? "discountFixed" : "discountPer";

        return (
            <div className="workZone flex1 flex minH0">
                <div className="left flex1 flex col">
                    <div className="label text blockTitle pad16">{this.tr("treatmentPlan.provisionalBill")}</div>
                    <div className="flex1 flex col minH0">
                        <div className="row headerText border flex text p1">
                            <div className="column first">{this._helper.string.capitalize(this.tr("client.teeth"))}</div>
                            <div className="column flex1">{this.tr("main.work")}</div>
                        </div>
                        <div
                            ref={el => this.invoicesCont = el}
                            className="flex1 scrolling auto"
                            onDragOver={e => { e.preventDefault(); }}
                            onDrop={this.onPricesContDrop.bind(this)}
                        >
                            {invoice.map((it, i) => this.insertInvoiceItem(i, it))}
                        </div>
                        <div className="row bottomText flex text p1">
                            <div className="column"></div>
                            <div className="column flex1 flex between">
                                <div className="info flex col gap16">
                                    <div>{this.tr("treatmentPlan.totalCost")}</div>
                                    <div className="flex centerV gap8" onClick={this.toggleState.bind(this, "isDiscFixed")/*null*/}>
                                        {this.tr("client.discount")}
                                        <div className="discount hand">{this.tr("treatmentPlan", discL)}</div>
                                    </div>
                                    <div>{this.tr("treatmentPlan.totalWithDiscount")}</div>
                                </div>
                                <div className="sums flex col gap16">
                                    <div>{this._helper.number.toSum(total)}</div>
                                    <div className="flex centerV">
                                        {this.insertInput({
                                            type: "number",
                                            value: disc,
                                            inputProps: {
                                                min: 0,
                                                max: isDiscFixed ? total : 100,
                                                step: 1,
                                            },
                                            validator: this._helper.inputValidators.number,
                                            onChange: this.changeDiscount.bind(this)
                                        })}
                                        <div>&nbsp;{isDiscFixed ? "₽" : "%"}</div>
                                    </div>
                                    <div className="text p1SemiBold">{this._helper.number.toSum(totalWithPercent)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="right flex col gap16">
                    <div className="label text blockTitle pad16">{this.tr("menu.price")}</div>
                    {this.insertSearch({
                        placeHolder: "main.search",
                        onChange: this.changeState.bind(this, "searchWord")
                    })}
                    <div className="flex1 flex col gap16 scrolling">{
                        items.map(it => this.insertPriceCat(it))
                    }</div>
                </div>
            </div>
        );
    }

    insertStepsHeaderItem(nText, n, step, text) {
        const cl = step === n ? "" : (step < n ? " will" : " done");

        return (
            <div className={"step flex centerV gap8 text blockTitle" + cl}>
                <div className="circle flex centerAll radCirc">{step > n ? <CheckIcon /> : nText}</div>
                <div className="text">{this.tr(text)}</div>
            </div>
        );
    }

    renderStepsHeader(step) {
        return (
            <div className="stepsHeader flex centerAll gap16">
                {this.insertStepsHeaderItem(1, 1, step, "treatmentPlan.totalInfo")}
                <div className="line"></div>
                {this.insertStepsHeaderItem(2, 2, step, "client.teethSelection")}
                <div className="line"></div>
                {this.insertStepsHeaderItem(3, 3, step, "treatmentPlan.scopeWork")}
            </div>
        );
    }

    renderStep(step) {
        if (step === 1)
            return this.renderFirstStep();
        if (step === 2)
            return this.renderSecondStep();

        return this.renderThirdStep();
    }

    renderContent() {
        const { step } = this.state;

        return (
            <div className="flex1 flex col gap32">
                {this.renderStepsHeader(step)}
                {this.renderStep(step)}
            </div>
        );
    }

    renderLeftButtons() {
        const { step } = this.state;

        if (step === 1)
            return <></>;

        return (
            <Button
                type="secondary"
                size="small"
                name="arrowLeft"
                label="main.back"
                onClick={this.stepBack.bind(this)}
            />
        );
    }

    renderButtons() {
        const { step } = this.state;

        this.dialogSaveTitle = step < 3 ? "main.continue" : "main.save";

        return super.renderButtons();
    }
}
